var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.30168 4.86613L12.1328 9.69727H2.47055L7.30168 4.86613Z",
    fill: "#2B2F3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.30168 19.1339L12.1328 14.3027H2.47055L7.30168 19.1339Z",
    fill: "#2B2F3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterButton);
export default __webpack_public_path__ + "static/media/filter-button.40be160911604aacd94154e0150a96e9.svg";
export { ForwardRef as ReactComponent };